var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-preloader",style:({
    display: _vm.displaying,
    opacity: _vm.opacity
  })},[_c('svg',{staticClass:"flag",attrs:{"xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"none","viewBox":"0 0 256 3"}},[_c('rect',{staticClass:"starting-color",attrs:{"width":"256","height":"3","y":"0","x":"0","fill":"#000"}}),_c('rect',{attrs:{"id":"replacing-color","width":_vm.percentage,"height":"3","y":"0","x":"0","fill":"#FFF"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }